import { addV6DebugInformation, clearAllV6DebugInformation } from '../../../../quotes/v6/v6-debug-information.js';
import {
  AskConfirmation,
  getConfirmationButtons,
  ConfirmationButtonType
} from '../../../../../webmodule-common/other/ui/modal-confirmation.js';
import { ButtonCaptionProvider, QuoteDataEntryView } from '../../../../quotes/views/quote-view.js';
import { customElement, state } from 'lit/decorators.js';
import { DealerReport } from '../../../../api/dealer-api-interface-clientagent.js';
import { fireQuickInformationToast } from '../../../../../webmodule-common/other/toast-away.js';
import { FranchiseeQuoteDEView, FranchiseeQuoteView } from '../franchisee-quote-view.js';
import { getApiFactory } from '../../../../api/api-injector.js';
import { userDataStore } from '../../../common/current-user-data-store';
import { getQuoteTitleStr } from '../../../../quotes/data/quote-helper-functions.js';
import { LangFranchiseeV6QuoteView } from '../../../../../localization/scripts/dealer-franchisee/quotes/views/v6/franchisee-v6-quote-view-lang';
import { v6Editors } from '../../../../../webmodule-common/interop/interfaces/v6-config.js';
import { v6Util } from '../../../../../webmodule-common/interop/interfaces/v6-config.js';
import { v6SupportsVersion } from '../../../../../webmodule-common/interop/interfaces/v6-config.js';
import { v6VersionMap } from '../../../../../webmodule-common/interop/interfaces/v6-config.js';
import {
  V6CustomItemRequestType,
  V6PickerFamilyButton
} from '../../../../../webmodule-common/interop/webmodule-interop.js';

@customElement('wm-franchiseev6quotedeview')
export class FranchiseeV6QuoteDEView extends FranchiseeQuoteDEView {
  protected clientAgentApi = getApiFactory().clientAgent();
  @state()
  frameButtons: (V6PickerFamilyButton | null)[] | null = null;
  @state()
  private customItemRequestTypes?: V6CustomItemRequestType[];

  buildFrameButtons(): (ButtonCaptionProvider | null)[] {
    return this.frameButtons ?? super.buildFrameButtons();
  }
  buildSpecialItemButtons(): (ButtonCaptionProvider | null)[] {
    if (userDataStore.isFabricatorMode) return [];
    return (
      this.customItemRequestTypes?.map(x => {
        return {
          caption: x.name,
          ...x
        };
      }) ?? super.buildSpecialItemButtons()
    );
  }
  public override async generateReportV2(dealerReport: DealerReport): Promise<boolean> {
    if (
      await AskConfirmation(
        LangFranchiseeV6QuoteView.reportGenerationDraftDialog(),
        getConfirmationButtons()[ConfirmationButtonType.yesNo],
        undefined,
        LangFranchiseeV6QuoteView.generateDraftReport()
      )
    ) {
      await this.clientAgentApi.generateReport({
        id: this.quote.id,
        dealerReport: dealerReport
      });

      fireQuickInformationToast(LangFranchiseeV6QuoteView.emailedLinkToDocument());
    }

    return false;
  }

  async dispose() {
    await super.dispose();

    await clearAllV6DebugInformation();

    //override if needed
  }

  public async afterConstruction(): Promise<void> {
    await super.afterConstruction();
    await this.quoteContainerManager.needsQuote();
    await this.quoteContainerManager.needsQuoteItems();
    if (v6SupportsVersion(v6VersionMap.hasMultipleFrameAdd)) {
      this.frameButtons = await v6Editors().getFramePickerButtons(this.quoteContainerManager.quote.supplierId);
    }
    // Skip loading custom item request types in fabricator mode — removes all custom
    // item request buttons (e.g., "Request Custom Frame") from the quote editor
    if (!userDataStore.isFabricatorMode && v6SupportsVersion(v6VersionMap.hasCustomItemRequestTypes)) {
      const atypes = await v6Util().getCustomItemRequestTypes(this.quoteContainerManager.quote.supplierId);
      if (atypes.length > 0) {
        this.customItemRequestTypes = atypes;
      }
    }
    await addV6DebugInformation('FranchiseeV6QuoteDEView', {
      quoteId: this.quote.id,
      quoteTitle: getQuoteTitleStr(this.quote, this.quoteContainerManager.quoteState)
    });
  }
}

@customElement('wm-franchiseev6quoteview')
export class FranchiseeV6QuoteView extends FranchiseeQuoteView {
  protected createView(): QuoteDataEntryView {
    return new FranchiseeV6QuoteDEView(this.options, this);
  }
}
